// src/pages/Portfolio.js
import React, { useEffect, useState } from 'react';
import { getPortfolioItems } from '../api/portfolioApi';
import LoadingSpinner from '../components/LoadingSpinner';

const Portfolio = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPortfolioItems()
      .then(res => setItems(res.data))
      .catch(err => console.error("Error fetching portfolio:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  const containerStyle = {
    maxWidth: '1100px',
    margin: '60px auto',
    padding: '0 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif'
  };

  const titleStyle = {
    fontSize: '2.2rem',
    fontWeight: 600,
    marginBottom: '3rem',
    textAlign: 'center',
    color: '#000',
    letterSpacing: '-0.02em'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2.5rem'
  };

  const cardStyle = {
    border: '1px solid #e5e5e5',
    borderRadius: '6px',
    padding: '0',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  };

  const imageStyle = {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '0'
  };

  const contentStyle = {
    padding: '1.5rem'
  };

  const titleStyleCard = {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: '0.75rem',
    color: '#000',
    letterSpacing: '-0.01em'
  };

  const descriptionStyle = {
    fontSize: '0.95rem',
    color: '#5f6368',
    lineHeight: 1.6,
    marginBottom: '1rem',
    fontWeight: 400
  };

  const linkStyle = {
    display: 'inline-block',
    color: '#0066cc',
    textDecoration: 'none',
    fontWeight: 600,
    transition: 'color 0.2s ease',
    fontSize: '0.95rem'
  };

  if (!items.length) {
    return (
      <div style={{ textAlign: 'center', marginTop: '80px', padding: '0 20px' }}>
        <p style={{ fontSize: '1.05rem', color: '#5f6368', fontWeight: 400 }}>
          No portfolio items available yet.
        </p>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Our Portfolio</h1>
      <div style={gridStyle}>
        {items.map(item => (
          <div 
            key={item.id} 
            style={cardStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.borderColor = '#d0d0d0';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
              e.currentTarget.style.borderColor = '#e5e5e5';
            }}
          >
            <img src={item.imageUrl} alt={item.title} style={imageStyle} />
            <div style={contentStyle}>
              <h3 style={titleStyleCard}>{item.title}</h3>
              <p style={descriptionStyle}>{item.description}</p>
              {item.link && (
                <a 
                  href={item.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={linkStyle}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#0052a3'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#0066cc'}
                >
                  View Project →
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
